import React from "react";
import "./gallery.css";
import ShadowImage from "react-image-shadow";
import "react-image-shadow/assets/index.css"; // Required CSS
import { galleryImg } from "../data";
export default function Gallery() {
  return (
    <div className="gallery">
      {galleryImg.map((item) => {
        return (
          <div key={item.id} className="gallery-item">
            <a href={item.image} target="_blank" rel="noreferrer">
              <ShadowImage src={item.image} alt={item.alt} />
            </a>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        );
      })}
    </div>
  );
}
